import { render } from "./HomeView.vue?vue&type=template&id=1d93b4d2&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=1d93b4d2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\vinicius.martins\\Desktop\\pasta\\teste\\projeto-automacao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d93b4d2"]])

export default __exports__